var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v(" Close ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }